export const REGISTRATIONS_BY_SESSION = `
  query Registrations($inputDates: DispatchForecastInputDates) {
    registrations {
      program_id
      program {
        id
        display_labels {
          label
          locale
        }
      }
      product_id
      product {
        prez_conf {
          display_dispatch_forecast_homepage
        }
      }
      portfolio_id
      dispatch_forecast(input_dates: $inputDates) {
        date
        day
        likelihood
        isAuditWindow
        auditText
        isHoliday
      }
    }
  }
`;

export const ERP_REGISTRATIONS = `
  query Registrations {
    registrations {
      program_id
      program {
        display_labels {
          label
          locale
        }
      }
      EMSReg {
        energy_reduction_plan
      }
      display_labels {
        label
        locale
      }
      id
      product_id
      product {
        prez_conf {
          display_erp_homepage
        }
    }
    }
  }
`;
